var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoffeeD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 336,
    viewBox: "0 0 224 336",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2125_118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.854 1H12.1464C5.99043 1 1 6.35654 1 12.9642V323.036C1 329.643 5.99043 335 12.1464 335H211.854C218.01 335 223 329.643 223 323.036V12.9642C223 6.35654 218.01 1 211.854 1Z",
    fill: "white",
    stroke: "#0B0B0B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2125_118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1893 37C19.6893 37 37.1893 19 37.1893 17C37.1893 19 54.6893 37 57.1893 37C54.6893 37 37.1893 55 37.1893 57C37.1893 55 19.6893 37 17.1893 37Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M142.771 159.417H140.75V155.375C140.75 152.159 139.472 149.075 137.199 146.801C134.925 144.527 131.841 143.25 128.625 143.25H80.125C76.9092 143.25 73.8252 144.527 71.5513 146.801C69.2775 149.075 68 152.159 68 155.375V195.792C68.0064 201.149 70.1376 206.286 73.926 210.074C77.7144 213.862 82.8507 215.994 88.2083 216H120.542C125.198 215.994 129.711 214.383 133.318 211.438C136.926 208.493 139.408 204.395 140.346 199.833C142.385 200.12 144.462 199.97 146.44 199.394C148.417 198.817 150.249 197.828 151.816 196.491C153.382 195.154 154.647 193.499 155.526 191.637C156.405 189.775 156.879 187.747 156.917 185.688V173.562C156.917 169.811 155.426 166.213 152.773 163.56C150.121 160.907 146.522 159.417 142.771 159.417ZM148.833 185.688C148.788 186.652 148.531 187.594 148.079 188.448C147.627 189.301 146.992 190.044 146.22 190.623C145.447 191.202 144.557 191.604 143.611 191.799C142.665 191.993 141.688 191.977 140.75 191.75V167.5C141.688 167.273 142.665 167.257 143.611 167.451C144.557 167.646 145.447 168.048 146.22 168.627C146.992 169.206 147.627 169.949 148.079 170.802C148.531 171.656 148.788 172.598 148.833 173.562V185.688ZM100.333 131.125V123.042C100.333 121.97 100.759 120.942 101.517 120.184C102.275 119.426 103.303 119 104.375 119C105.447 119 106.475 119.426 107.233 120.184C107.991 120.942 108.417 121.97 108.417 123.042V131.125C108.417 132.197 107.991 133.225 107.233 133.983C106.475 134.741 105.447 135.167 104.375 135.167C103.303 135.167 102.275 134.741 101.517 133.983C100.759 133.225 100.333 132.197 100.333 131.125ZM116.5 131.125V123.042C116.5 121.97 116.926 120.942 117.684 120.184C118.442 119.426 119.47 119 120.542 119C121.614 119 122.642 119.426 123.4 120.184C124.157 120.942 124.583 121.97 124.583 123.042V131.125C124.583 132.197 124.157 133.225 123.4 133.983C122.642 134.741 121.614 135.167 120.542 135.167C119.47 135.167 118.442 134.741 117.684 133.983C116.926 133.225 116.5 132.197 116.5 131.125ZM84.1667 131.125V123.042C84.1667 121.97 84.5925 120.942 85.3504 120.184C86.1084 119.426 87.1364 119 88.2083 119C89.2802 119 90.3082 119.426 91.0662 120.184C91.8242 120.942 92.25 121.97 92.25 123.042V131.125C92.25 132.197 91.8242 133.225 91.0662 133.983C90.3082 134.741 89.2802 135.167 88.2083 135.167C87.1364 135.167 86.1084 134.741 85.3504 133.983C84.5925 133.225 84.1667 132.197 84.1667 131.125Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2125_118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.189 299C168.689 299 186.189 281 186.189 279C186.189 281 203.689 299 206.189 299C203.689 299 186.189 317 186.189 319C186.189 317 168.689 299 166.189 299Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2125_118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 224,
    height: 336,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2125_118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 40,
    fill: "white",
    transform: "translate(17 17)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2125_118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 40,
    fill: "white",
    transform: "translate(166 279)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffeeD);
export default __webpack_public_path__ + "static/media/CoffeeD.4440a9fcc4bd5a40ed54cc0ed33c35bc.svg";
export { ForwardRef as ReactComponent };